import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import HomePage from './components/HomePage';
import ExplorePage from './components/ExplorePage';
import ProfilePage from './components/UserPage';
import Profile from './components/ProfilePage';
import Login from './components/Login';
import ArticleView from './components/ArticleView';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import FAQ from './components/FAQ';
import Feedback from './components/Feedback';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import CommunityGuidelines from './components/CommunityGuidelines';
import BioEditor from './components/BioEditor';
import BlogPostEditor from './components/BlogPostEditor';

function AppContent() {
  const location = useLocation();
  const isEditorPage = location.pathname.startsWith('/editor');

  return (
    <div className="App">
      <Navigation />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="/bio" element={
            <ProtectedRoute>
              <BioEditor />
            </ProtectedRoute>
          } />
          <Route path="/bio/:slug" element={
            <ProtectedRoute>
              <BioEditor />
            </ProtectedRoute>
          } />
          <Route path="/editor" element={
            <ProtectedRoute>
              <BlogPostEditor existing={false} />
            </ProtectedRoute>
          } />
          <Route path="/editor/:slug" element={
            <ProtectedRoute>
              <BlogPostEditor existing={true} />
            </ProtectedRoute>
          } />
          <Route path="/blog/:slug" element={<ArticleView />} />
          <Route path="/users/:username" element={<ProfilePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/guidelines" element={<CommunityGuidelines />} />
        </Routes>
      </main>
      {!isEditorPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
